export default {
    regSeason: {
        standings: [
            { manager: 'Scott', wins: 11, losses: 3, pf: 2124.28},
            { manager: 'Aidan', wins: 10, losses: 4, pf: 1935.52},
            { manager: 'Davis', wins: 10, losses: 4, pf: 2265.74, champ: true},
            { manager: 'Conor', wins: 8, losses: 6, pf: 2198.18},
            { manager: 'Tommy', wins: 8, losses: 6, pf: 1965.94},
            { manager: 'Kieffer', wins: 7, losses: 7, pf: 2021.78},
            { manager: 'Dan', wins: 7, losses: 7, pf: 1882.78},
            { manager: 'Mike', wins: 6, losses: 8, pf: 1907.88},
            { manager: 'Taylor', wins: 6, losses: 8, pf: 1700.66},
            { manager: 'Tench', wins: 5, losses: 9, pf: 1608.64},
            { manager: 'Steve', wins: 5, losses: 9, pf: 1581.98, sacko: true},
            { manager: 'Zane', wins: 1, losses: 13, pf: 1009.02 }
        ]
    },
    playoffs: {
        teamData: {
            Conor: {
                seed: 4
            },
            Tommy: {
                seed: 5
            },
            Kieffer: {
                seed: 6
            },
            Davis: {
                seed: 3
            },
            Aidan: {
                seed: 2
            },
            Scott: {
                seed: 1
            }
        },
        gameData: [
            {
                name: 'Caleci-Fairlawn-Kennedy Championship Game',
                games: [
                    {
                        Davis: 150.1,
                        Scott: 117.38
                    }
                ],
                props: {
                    winnerIcon: 'trophyGold bi bi-trophy-fill',
                    loserIcon: 'trophySilver bi bi-trophy-fill',
                }
            },
            {
                name: 'Thomas McGrath Award',
                games: [
                    {
                        Aidan: 191.1,
                        Conor: 196.96
                    }
                ],
                props: {
                    winnerIcon: 'trophyBronze bi bi-trophy-fill',
                }
            },
            {
                name: 'Semifinals',
                games: [
                    {
                        Davis: 213.88,
                        Aidan: 159.36
                    },
                    {
                        Conor: 111.26,
                        Scott: 209.44
                    }
                ]
            },
            {
                name: 'Wildcard',
                games: [
                    {
                        Davis: 150.4,
                        Kieffer: 150
                    },
                    {
                        Conor: 131.56,
                        Tommy: 75.48
                    }
                ]
            },
        ]
    },
    draft: {
        order: ['Scott', 'Mike', 'Zane', 'Tommy', 'Tench', 'Steve', 'Davis', 'Aidan', 'Conor', 'Kieffer', 'Taylor', 'Dan'],
        picks: [
            {manager: 'Scott', pick: 'Derrick henry'},
            {manager: 'Dan', pick: 'Najee harris'},
            {manager: 'Scott', pick: 'Aaron Jones'},
            {manager: 'Davis', pick: 'Deandre hopkins'},
            {manager: 'Mike', pick: 'George Kittle'},
            {manager: 'Davis', pick: 'Joe mixon'},
            {manager: 'Davis', pick: 'Kyle pitts'},
            {manager: 'Steve', pick: 'Javonte williams'},
            {manager: 'Mike', pick: 'DJ Moore'},
            {manager: 'Conor', pick: 'Jamaar Chase'},
            {manager: 'Scott', pick: 'Michael thomas'},
            {manager: 'Dan', pick: 'Julio Jones'},
            {manager: 'Scott', pick: 'Mark Andrews'},
            {manager: 'Tench', pick: 'Devonta Smith'},
            {manager: 'Dan', pick: 'Brandin cooks'},
            {manager: 'Steve', pick: 'Kareem hunt'},
            {manager: 'Scott', pick: 'Trey sermon'},
            {manager: 'Tommy', pick: 'Damien harris'},
            {manager: 'Zane', pick: 'Michael Carter'},
            {manager: 'Kieffer', pick: 'Jaylen Waddle'},
            {manager: 'Zane', pick: 'Travis Etienne'},
            {manager: 'Kieffer', pick: 'Corey Davis'},
            {manager: 'Taylor', pick: 'Tyler Lockett'},
            {manager: 'Dan', pick: 'Tyler higbee'},
            {manager: 'Steve', pick: 'Ronald Jones II'},
            {manager: 'Conor', pick: 'Jalen Hurts'},
            {manager: 'Dan', pick: 'Elijah Moore'},
            {manager: 'Kieffer', pick: 'Logan Thomas'},
            {manager: 'Tommy', pick: 'Curtis Samuel'},
            {manager: 'Dan', pick: 'Latavius Murray'},
            {manager: 'Zane', pick: 'Trevor Lawrence'},
            {manager: 'Steve', pick: 'Rashod Bateman'},
            {manager: 'Conor', pick: 'Rondale Moore'},
            {manager: 'Mike', pick: 'Justin Fields'},
            {manager: 'Aidan', pick: 'Amon-ra St. Brown'},
            {manager: 'Dan', pick: 'Nelson Agholor'},
            {manager: 'Tommy', pick: 'Melvin Gordon III'},
            {manager: 'Mike', pick: 'Terrace Marshall'},
            {manager: 'Tench', pick: 'Matty Stafford'},
            {manager: 'Tommy', pick: 'Michael Gallup'},
            {manager: 'Zane', pick: 'Chuba Hubbard'},
            {manager: 'Steve', pick: 'marquez callaway'},
            {manager: 'Davis', pick: 'Trey Lance'},
            {manager: 'Aidan', pick: 'Ryan Tannehill'},
            {manager: 'Tommy', pick: 'Tom Brady'},
            {manager: 'Kieffer', pick: 'Alexander Mattinson'},
            {manager: 'Taylor', pick: 'Jakobi Meyers'},
            {manager: 'Dan', pick: 'Steelers D/ST'},
            {manager: 'Scott', pick: 'Mike Gesicki'},
            {manager: 'Aidan', pick: 'Salvon Ahmed'},
            {manager: 'Mike', pick: 'Bryan Edwards'},
            {manager: 'Tommy', pick: 'Leonard Fournette'},
            {manager: 'Zane', pick: 'Tutu atwell'},
            {manager: 'Steve', pick: 'Kenneth Gainwell'},
            {manager: 'Davis', pick: 'Nyheim Hines'},
            {manager: 'Aidan', pick: 'Darryington Evans'},
            {manager: 'Conor', pick: 'Bucaneers D'},
            {manager: 'Kieffer', pick: 'Washington D'},
            {manager: 'Taylor', pick: 'Amari Rogers'},
            {manager: 'Dan', pick: 'David Johnson'},
            {manager: 'Scott', pick: 'Colts D'},
            {manager: 'steve', pick: 'Pat freiermuth'},
            {manager: 'Zane', pick: 'Justin Tucker'},
            {manager: 'Tommy', pick: 'Gus Edwards'},
            {manager: 'Zane', pick: 'Qadree ollison'},
            {manager: 'Davis', pick: 'Phillip Lindsay'},
            {manager: 'Davis', pick: 'Jonnu smith'},
            {manager: 'Steve', pick: 'Sterling Shepherd'},
            {manager: 'Conor', pick: 'Randall Cobb'},
            {manager: 'Kieffer', pick: 'MVS'},
            {manager: 'Taylor', pick: 'Tony Pollard'},
            {manager: 'Dan', pick: 'Benny Snell'},
            {manager: 'Aidan', pick: 'Dwayde Eskridge'},
            {manager: 'Mike', pick: 'niners D'},
            {manager: 'Mike', pick: 'harrison butker'},
            {manager: 'Tommy', pick: 'tyrell williams'},
            {manager: 'Zane', pick: 'james washington'},
            {manager: 'Steve', pick: 'graham gano'},
            {manager: 'Davis', pick: 'zach wilson'},
            {manager: 'Scott', pick: 'yunghoe koo'},
            {manager: 'Conor', pick: 'matt gay'},
            {manager: 'Kieffer', pick: 'boston scott'},
            {manager: 'Taylor', pick: 'ryan fitz'},
            {manager: 'Dan', pick: 'tyler bass'},
        ]
    }
}